import React from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton as ActionButtonType } from 'types/button';
import { LinkButton as LinkButtonType } from 'types/button';
import { Meta } from 'types/meta';
import linkIcon from 'images/linkIcon.svg';
import arrowIcon from 'images/arrowIcon.svg';
import { NavigationButton } from './NavigationButton';
import { getTranslation } from 'localization/helpers';
import { Button } from 'styles/Button';
import { ActionButton } from './ActionButton';

interface LinkButtonProps {
  button: LinkButtonType;
  index: number;
  meta: Meta;
}

// todo move two following functions to support methods
const isLinkButton = (
  button: ActionButtonType | LinkButtonType,
  locale: string
): button is LinkButtonType => {
  if (!button.translations || !button.translations[locale]) return false;
  return 'link' in button.translations[locale];
};

export const formDataFromObject = (data: { [name: string]: string }) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => formData.append(key, value));
  return formData;
};

export const renderButton = (
  button: ActionButtonType | LinkButtonType,
  index: number,
  meta: Meta,
  payload: { [name: string]: string }
) => {
  return isLinkButton(button, meta.default_locale) ? (
    <LinkButton button={button} index={index} meta={meta} />
  ) : (
    <ActionButton button={button} index={index} meta={meta} payload={payload} />
  );
};

export const LinkButton: FC<LinkButtonProps> = ({ button, index, meta }) => {
  const { i18n } = useTranslation();
  let text = getTranslation(
    button.translations,
    'text',
    i18n.language,
    meta.default_locale
  );
  if (!text) text = '';

  const link = getTranslation(
    button.translations,
    'link',
    i18n.language,
    meta.default_locale
  );
  if (!link) return <div />;
  return (
    <Button
      key={index}
      onClick={() => {
        window.location.href = link;
        return null;
      }}
    >
      <NavigationButton
        text={text}
        color={meta.color}
        icon={linkIcon}
        arrow={arrowIcon}
      />
    </Button>
  );
};
